import { render, staticRenderFns } from "./AgentMessageBubble.vue?vue&type=template&id=deca6a0e&scoped=true&"
import script from "./AgentMessageBubble.vue?vue&type=script&lang=js&"
export * from "./AgentMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./AgentMessageBubble.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AgentMessageBubble.vue?vue&type=style&index=1&id=deca6a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca6a0e",
  null
  
)

export default component.exports